<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    let { attributes = {}, children } = $props();

    let isLocal = $derived(!attributes.href || attributes.href.trim().startsWith('#'));
</script>

<a
    href={attributes.href}
    target={isLocal ? void 0 : '_blank'}
    rel={isLocal ? void 0 : 'noopener noreferrer'}
    {...attributes}>{@render children?.()}</a>
